import { Environment } from 'app/enums';
import { Identifier } from 'app/interfaces';
import TagManager from 'react-gtm-module';
import config from 'config/config';

const tagManagerArgs = {
  gtmId: config.gtmId,
};

export const initTagManager = (identifier?: Identifier, authenticated?: boolean): void => {
  if (config.frontendEnvironment === Environment.Local) {
    return;
  }

  TagManager.initialize({
    ...tagManagerArgs,
    dataLayer: {
      userId: identifier ?? '',
      isAuthorized: authenticated ? 1 : 0,
    },
  });
};
